import React, { Fragment, useEffect, useState } from 'react';
import Address from './../Address/Address';
import Axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';

const Main = () => {
  const [banners, setBanners] = useState([]); // 배너 데이터를 저장할 상태
  const [gameList, setGameList] = useState([]);
  const [newsList, setNewsList] = useState([]); // 뉴스 데이터를 저장할 상태

  // 메인배너
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await Axios.get('http://plassion.co.kr:8444/api/get/user_banner_list', {
          params: {
            type: 1, // type 파라미터에 1을 전송
          },
        });
        setBanners(response.data);
      } catch (error) {
        console.error('배너 데이터 가져오기 오류:', error);
      }
    };

    const fetchGames = async () => {
      try {
        const response = await Axios.get('http://plassion.co.kr:8444/api/get/user_games_list');
        setGameList(response.data);
        console.log('gameList', gameList);
      } catch (error) {
        console.error('배너 데이터 가져오기 오류:', error);
      }
    };

    const fetchNews = async () => {
      try {
        const response = await Axios.get('http://plassion.co.kr:8444/api/get/news_list'); // 뉴스 API 호출
        setNewsList(response.data);
      } catch (error) {
        console.error('뉴스 데이터 가져오기 오류:', error);
      }
    };

    fetchBanners();
    fetchGames();
    fetchNews();
  }, []);

  console.log('banners', banners);
  console.log('newsList', newsList);

  return (
    <Fragment>
      <main>
        <section className="first-section">
          <Swiper
            modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            scrollbar={{ draggable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            effect="fade"
            fadeEffect={{ crossFade: true }}
            speed={800}
          >
            {banners && banners.length > 0 ? (
              banners.map((banner, index) => (
                <SwiperSlide className="swiper-slide" key={index}>
                  <div
                    className={`slide-image s-img${index + 1}`}
                    style={{
                      backgroundImage: `url(http://plassion.co.kr:8444/${banner.file_url.replace(/\\/g, '/')})`,
                    }}
                  ></div>
                </SwiperSlide>
              ))
            ) : (
              <div>배너가 없습니다.</div>
            )}
          </Swiper>
        </section>

        <section className="second-section">
          <h2>GAMES</h2>
          <div className="game-boxes">
            {gameList && gameList.length > 0 ? (
              gameList.map((game, index) => (
                <div className="game-box" key={index}>
                  <div
                    className="game-box-img"
                    style={{ backgroundImage: `url(http://plassion.co.kr:8444/${game.img1.replace(/\\/g, '/')})` }}
                  ></div>
                </div>
              ))
            ) : (
              <div>게임 데이터가 없습니다.</div>
            )}
          </div>
        </section>

        <section className="third-section">
          <h2>NEWS</h2>
          <div className="news-grid">
            {newsList.map((news, index) => (
              <div className="news-box" key={index}>
                <div className="image-container">
                  <img src={`http://plassion.co.kr:8444/uploads/${news.img1}`} alt={news.title} />
                  <div className="news-hover">
                    <p>상세보기</p>
                  </div>
                </div>
                <div className="news-content">
                  <h3>{news.title}</h3>
                  <p>{news.content.replace(/<[^>]+>/g, '')}</p>
                  <p className="last-txt">
                    {news.writer} &nbsp;{new Date(news.date).toISOString().split('T')[0]} &nbsp;조회수: {news.hit}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
      <Address />
    </Fragment>
  );
};

export default Main;
